import { makeGet, makePost, makePut, makeDelete } from './ServiceManager';

export const getUtmProfiles = async () => {
  const result = await makeGet('service/utmprofile/utmprofiles');
  return result;
};

export const insertUtmProfile = async (utm) => {
  const result = await makePost('service/utmprofile/utmprofile', { utm });
  return result;
};

export const updateUtmProfile = async (utm) => {
  const result = await makePut('service/utmprofile/utmprofile', { utm });
  return result;
};

export const deleteUtmProfile = async (id) => {
  const result = await makeDelete('service/utmprofile/utmprofile', { id });
  return result;
};



// WEBPACK FOOTER //
// ./src/services/UtmProfilesService.js